import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { JwtService } from "src/app/shared/Services/jwt.service";
import { StorageService } from "src/app/shared/Services/storage.service";
import { UserType } from "src/app/shared/Constants/user-type";
import { SharedService } from "src/app/shared/Services/shared.service";
import { LoggingService } from "src/app/shared/Services/NGLogger/logging-service.service";
import { FilterStateService } from "src/app/shared/Services/filter-state.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  //#region
  Menu = [
    {
      title: "Dashboard",
      name: "dashboard",
      permission: "Permissions.Dashboards.View",
      imageLink: "/../assets/images/dashboard.svg",
      routerLink: "/dashboard",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: true
    },
    {
      title: "Clients",
      name: "Client",
      permission: "Permissions.Enterprise.View",
      imageLink: "/../assets/images/icons/enterprises.svg",
      routerLink: "/enterprise/index",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: false
    },
    {
      title: "Suppliers",
      name: "epStaffing",
      permission: "Permissions.Suppliers.View",
      imageLink: "/../assets/images/icons/agency.svg",
      routerLink: "/supplier/index",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: true
    },
    {
      title: "Job Requests",
      name: "epJobs",
      permission: "Permissions.JobRequest.View",
      imageLink: "/../assets/images/icons/myjob.svg",
      routerLink: "/jobrequest/index",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: true
    },
    {
      title: "Users",
      name: "users",
      permission: "Permissions.Users.View",
      imageLink: "/../assets/images/icons/interview.svg",
      routerLink: "/user/manage",
      resetpwdRouterLink: "/user/manage",
      IsClientIdReq: true
    },
    {
      title: "Interviews",
      name: "interview",
      permission: "Permissions.INTERVIEWS.View",
      imageLink: "/../assets/images/icons/interview.svg",
      routerLink: "/ep/enterprise/Interview",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: true
    },
    {
      title: "Job Seekers",
      name: "Jobseeker",
      permission: "Permissions.Jobseeker.View",
      imageLink: "/../assets/images/icons/job-seeker.svg",
      routerLink: "/jobseeker/index",
      resetpwdRouterLink: "/jobseeker/index",
      IsClientIdReq: true
    },
    {
      title: "Supplier Groups",
      name: "SupplierGroup",
      permission: "Permissions.SupplierGroup.View",
      imageLink: "/../assets/images/icons/agency-group.svg",
      routerLink: "/supplier/group",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: true
    },
    {
      title: "Invoices",
      name: "invoice",
      permission: "Permissions.Invoice.View",
      imageLink: "/../assets/images/invoice.png",
      routerLink: "/ep/enterprise/invoice",
      resetpwdRouterLink: "/ep/enterprise/resetpassword",
      IsClientIdReq: null
    },
    {
      title: "Candidates",
      name: "candidate",
      permission: "Permissions.Canidates.View",
      imageLink: "/../assets/images/icons/mycandidates.svg",
      routerLink: "/jobseeker/index",
      resetpwdRouterLink: "/st/staff/resetpassword",
      IsClientIdReq: null
    },
  ];

  Permission: any = [];
  sidebarMenu: any;
  activeRoute: any;
  IsLogin: boolean = false;
  linkActive: any;
  status!: boolean;
  Utype: any;
  UserType: string = '';
  //#endregion
  @Input() open = new EventEmitter();
  selectedClientId!: any;
  constructor(
    private jwtService: JwtService,
    public storageService: StorageService,
    private sharedService: SharedService,
    private loggingService: LoggingService,
    private elementRef: ElementRef,
    private stateService: FilterStateService,
    private router: Router
  ) {
    this.sharedService.selectedClientId$.subscribe(clientId => {
      this.selectedClientId = clientId ?? localStorage.getItem('selectedClientId');
      if (this.selectedClientId > 0)
        this.setMenu();
      else if (this.selectedClientId == 0) {
        this.setMenu();
      }
    },
      err => { this.loggingService.captureException(err); }
    );
    this.IsLogin = this.storageService.isLoggedIn();

    this.Utype = UserType;
    if (this.IsLogin)
      this.setMenu();
  }
  ngDoCheck() {
    if (this.UserType == this.Utype?.Supplier) {
    this.setMenu()
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if ('selectedClientId' in changes) {
      const newJsId = changes['selectedClientId'].currentValue ?? 0;
      this.setMenu();
    }
  }
  // viewCardView() {
  //   localStorage.removeItem('supplierClientId')
  //   localStorage.removeItem('selectedClientName')
  //   this.isselectedSclientId = false;
  //   this.sharedService.setsupplierSelectedClientId(0);
  //   this.router.navigate(['/dashboard']);

  // }
  setMenu() {
    this.UserType = this.jwtService.getUserType();
    this.Permission = this.jwtService.getPermissions();
    if (this.UserType == this.Utype?.Admin) {
      if (this.selectedClientId == null) {
        this.sidebarMenu = this.Menu.filter((item1) =>
          this.Permission.some((item2: string) => item1.permission === item2 && !item1.IsClientIdReq && item1.IsClientIdReq != null))
      }
    }
    else {
      if (this.Permission != null && this.Menu != null) {
        this.sidebarMenu = this.Menu.filter((item1) =>
          this.Permission.some((item2: string) => item1.permission === item2 && item1.IsClientIdReq != null));
      }
    }

    if (this.selectedClientId > 0) {
      this.sidebarMenu = this.Menu.filter((item1) =>
        this.Permission.some((item2: string) => item1.permission === item2 && item1.IsClientIdReq && item1.IsClientIdReq != null))
    }
    else if (this.selectedClientId == 0) {
      this.sidebarMenu = this.Menu.filter((item1) =>
        this.Permission.some((item2: string) => item1.permission === item2 && !item1.IsClientIdReq && item1.IsClientIdReq != null))
    }
    if (this.sidebarMenu != null) {
      const dashboardMenuItem = this.Menu.find(item => item.name === 'dashboard');
      if (dashboardMenuItem && !this.sidebarMenu.some((item: { name: string; }) => item.name === 'dashboard')) {
        this.sidebarMenu.unshift(dashboardMenuItem);
      }
    }
    if (this.sidebarMenu != null) {
      const usersMenuItem = this.Menu.find(item => item.name === 'users');
      if (usersMenuItem && this.UserType !== this.Utype?.JobSeeker && (!this.sidebarMenu.some((item: { name: string; }) => item.name === 'users'))) {
        this.sidebarMenu.push(usersMenuItem);
      }
    }
    if (this.UserType == this.Utype?.Supplier) {
      if (this.sidebarMenu != null) {
        this.sidebarMenu.forEach((element: any, index: number) => {
          if ((element.name == "epJobs" || element.name=="Jobseeker") && localStorage.getItem('issupplierMultipleClient') && (!localStorage.getItem('supplierClientId'))) {
            this.sidebarMenu.splice(index, 1);
          }
        });
      }
    }
  }
  ngOnInit() {
    this.UserType = this.jwtService.getUserType();
    const jobRequestMenu = this.Menu.find(menuItem => menuItem.name === "epJobs");
    if (jobRequestMenu) {
      jobRequestMenu.routerLink =
        this.UserType === this.Utype.JobSeeker
          ? "/jobrequest/jsindex"
          : "/jobrequest/index";
    }
  }

  ngOnDestroy() { }

  //  New changes
  activeLinks(val: any) {
    this.linkActive = val;
    this.stateService.resetAllFilterState();
  }

  openMenu() {
    this.status = !this.status;
    var element = document.getElementById("accordionSidebar");
    var element2 = document.getElementById("mainwrapper");
    if (this.status) {
      element?.classList.remove("toggled");
      element2?.classList.remove("closemenu");
    } else {
      element?.classList.add("toggled");
      element2?.classList.add("closemenu");
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (this.status && !this.elementRef.nativeElement.contains(event.target)) {
      this.closeMenu();
    }
  }

  closeMenu() {
    this.status = false;
    var element = document.getElementById("accordionSidebar");
    var element2 = document.getElementById("mainwrapper");
    element?.classList.add("toggled");
    element2?.classList.add("closemenu");
  }
}
